import pick from 'lodash/fp/pick';

import { TemplatesFilterData } from '../../store/modules/filter';

const getTemplateFiltersByQuery = <T extends TemplatesFilterData>(query: T) =>
  pick<T, keyof TemplatesFilterData>(
    ['name', 'category', 'aspects', 'platforms', 'formats', 'price_max', 'price_min'],
    query
  );

export default getTemplateFiltersByQuery;
